// Decides whether the cart needs the Free Academy Access ride-along line.
// Pure: no fetch, no DOM. Loaded by layout/theme.liquid; the cart drawer calls window.bbAcademyPlan.
(function (root) {
  function academyPlan(items, cfg) {
    if (!cfg || !cfg.enabled || !cfg.variantId) return null;
    var list = items || [];
    var handle = String(cfg.handle || 'free-academy-access').toLowerCase();
    var acad = null, physical = false;
    for (var i = 0; i < list.length; i++) {
      var it = list[i], h = String(it.handle || '').toLowerCase();
      if (h === handle) { if (!acad) acad = it; continue; }
      if (it.requires_shipping) physical = true;
    }
    if (physical && !acad) return { op: 'add', id: cfg.variantId };
    if (acad && !physical) return { op: 'remove', key: acad.key };
    if (acad && acad.quantity !== 1) return { op: 'set', key: acad.key, quantity: 1 };
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { academyPlan: academyPlan };
  if (root) root.bbAcademyPlan = academyPlan;
})(typeof window !== 'undefined' ? window : null);
